// react_frontend/src/Components/Modules/Accounting/BankReconciliation.js
import React, { useState, useEffect } from 'react';
import { AxiosAuthInstance } from '../../../AxiosInterceptors';
import Breadcrumb from '../../Partials/Breadcrumb';
import {
    Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, FormControl, InputLabel, Select, MenuItem, Chip
} from '@mui/material';
import { FaSearch, FaCheck } from 'react-icons/fa';

export default function BankReconciliation() {
    const [bankAccounts, setBankAccounts] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const fetchBankRecon = async () => {
        try {
            const res = await AxiosAuthInstance.get('accounting/reports/bank-reconciliation', {
                params: { account_id: selectedAccount, from_date: fromDate, to_date: toDate }
            });
            setBankAccounts(res.data.bank_accounts || []);
            setTransactions(res.data.transactions || []);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => { fetchBankRecon(); }, []);

    const handleReconcile = async (id) => {
        try {
            await AxiosAuthInstance.post(`accounting/reports/bank-reconciliation/${id}`, { reconciled: true });
            fetchBankRecon();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Box sx={{ p: 3, bgcolor: '#f5f7fa', minHeight: '100vh' }}>
            <Breadcrumb title="Bank Reconciliation" />
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h5" fontWeight={700} mb={2}>Bank Reconciliation</Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel>Bank Account</InputLabel>
                        <Select value={selectedAccount} label="Bank Account" onChange={(e) => setSelectedAccount(e.target.value)}>
                            {bankAccounts.map(acc => (
                                <MenuItem key={acc.id} value={acc.id}>{acc.account_name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField label="From Date" type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <TextField label="To Date" type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} size="small" InputLabelProps={{ shrink: true }} />
                    <Button variant="contained" onClick={fetchBankRecon} startIcon={<FaSearch />}>Load</Button>
                </Box>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                                <TableCell>Date</TableCell>
                                <TableCell>Entry #</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell align="right">Debit</TableCell>
                                <TableCell align="right">Credit</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactions.map((txn, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{txn.date}</TableCell>
                                    <TableCell><code>{txn.entry_number}</code></TableCell>
                                    <TableCell>{txn.description}</TableCell>
                                    <TableCell align="right">{Number(txn.debit).toLocaleString()}</TableCell>
                                    <TableCell align="right">{Number(txn.credit).toLocaleString()}</TableCell>
                                    <TableCell>
                                        <Chip label={txn.reconciled ? 'Reconciled' : 'Pending'} color={txn.reconciled ? 'success' : 'warning'} size="small" />
                                    </TableCell>
                                    <TableCell align="center">
                                        {!txn.reconciled && (
                                            <Button size="small" variant="outlined" onClick={() => handleReconcile(txn.id)} startIcon={<FaCheck />}>Reconcile</Button>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
}